import React from "react";
import { cssVariables } from "./css_variables";
import { stylex } from "./stylex";

interface DividerProps {
  children?: React.ReactNode;
  color?: string;
  orientation?: "vertical" | "horizontal";
  className?: string;
}

/**
 * Visual separator between components.
 */
export function Divider(props: DividerProps) {
  const {
    children,
    color = cssVariables.borderColorDefault,
    orientation = "horizontal",
    className,
  } = props;

  return (
    <div
      className={className}
      style={{ ...styles(orientation), backgroundColor: color }}
    >
      {children}
    </div>
  );
}

const styles = stylex.create({
  horizontal: {
    width: "100%",
    height: 1,
  },
  vertical: {
    height: "100%",
    width: 1,
  },
});
